export default "__VITE_ASSET__C505kQSk__"